import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

const currentYear = new Date().getFullYear()

export const useYearPeriodStore = create(
  persist(
    set => ({
      year: currentYear,
      setYear: year => set({ year }),
    }),
    {
      name: 'year-period',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
